import { MmdRuntimeShared } from "./mmdRuntimeShared";
import { MmdStandardMaterialProxy } from "./mmdStandardMaterialProxy";
MmdRuntimeShared.MaterialProxyConstructor = MmdStandardMaterialProxy;
